module.exports = __webpack_public_path__ + "static/media/duns-number.f3734377.svg";